export class GlobalService{
    public static getBasepath(){
        return '';
    }
}